import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { ApiUrlHelper } from "./api-url-helper";
import { HttpClientHelper } from "./http-helper";
declare var injectJson;
@Injectable({
    providedIn: "root"
})
export class InjectHttpClient {
    constructor(private _httpClientHelper: HttpClientHelper,
        private _apiUrlHelper: ApiUrlHelper,

    ) {

    }

    get(key: string,params:any = {},cacheAble = false): Observable<any> {
        let objKeys = Object.keys(params);
        let cacheKey = key;
        objKeys.forEach(key=>{
            cacheKey+="_"+key+"_"+params[key];
        })
        if (!!injectJson[cacheKey]) {
            let result =  of(injectJson[cacheKey]);
            delete injectJson[cacheKey];
            return result;
        }
        const url = this._apiUrlHelper.urlBuilder(key,params);
        return cacheAble?this._httpClientHelper.getWithCache(url):this._httpClientHelper.get(url);

    }
}
